export const _set_user_to_localStorage = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
};

export const _get_user_from_localStorage = () => {
  return JSON.parse(localStorage.getItem("user"));
};
